import React from 'react';
import { motion } from 'framer-motion';
import { SlideLayout } from '../SlideLayout';
import { OpenFpgaLogo } from '../OpenFpgaLogo';
import { ArrowRight } from 'lucide-react';
export function CtaSlide() {
  return <SlideLayout slideNumber={18} totalSlides={20} hideLogo data-id="element-73">
      <div className="flex flex-col items-center justify-center h-full text-center" data-id="element-74">
        <motion.div initial={{
        scale: 0.9,
        opacity: 0
      }} animate={{
        scale: 1,
        opacity: 1
      }} transition={{
        duration: 0.6
      }} className="mb-8" data-id="element-75">
          <OpenFpgaLogo size="xl" data-id="element-76" />
        </motion.div>

        <motion.h2 initial={{
        y: 20,
        opacity: 0
      }} animate={{
        y: 0,
        opacity: 1
      }} transition={{
        delay: 0.2
      }} className="text-4xl md:text-6xl font-bold text-white mb-12" data-id="element-77">
          Ready to Accelerate Your <br data-id="element-78" />
          <span className="text-brand-primary" data-id="element-79">AI Inference?</span>
        </motion.h2>

        <motion.div initial={{
        y: 20,
        opacity: 0
      }} animate={{
        y: 0,
        opacity: 1
      }} transition={{
        delay: 0.4
      }} className="flex flex-col md:flex-row gap-6" data-id="element-80">
          <a href="https://docs.google.com/forms/d/e/1FAIpQLSeA3akOwONwkYJLK4nX5RaNw1wlVWWLd6dPKvH2FSMPjvA9IA/viewform" target="_blank" rel="noopener noreferrer" className="px-8 py-4 bg-brand-primary text-brand-dark font-bold rounded-lg text-lg hover:bg-brand-primary/90 transition-colors" data-id="element-81">
            Get API Key
          </a>
          <a href="https://docs.google.com/forms/d/e/1FAIpQLSeA3akOwONwkYJLK4nX5RaNw1wlVWWLd6dPKvH2FSMPjvA9IA/viewform" target="_blank" rel="noopener noreferrer" className="px-8 py-4 bg-transparent border border-brand-border text-white font-bold rounded-lg text-lg hover:bg-brand-surface transition-colors flex items-center gap-2" data-id="element-82">
            Explore Accelerators <ArrowRight size={20} data-id="element-83" />
          </a>
        </motion.div>

        <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} transition={{
        delay: 0.8
      }} className="mt-16" data-id="element-84">
          <a href="https://docs.google.com/forms/d/e/1FAIpQLSeA3akOwONwkYJLK4nX5RaNw1wlVWWLd6dPKvH2FSMPjvA9IA/viewform" target="_blank" rel="noopener noreferrer" className="text-brand-muted font-mono hover:text-brand-primary transition-colors" data-id="element-85">
            openfpga.ai
          </a>
        </motion.div>
      </div>
    </SlideLayout>;
}